import { Component, OnInit } from '@angular/core';
import { FormGroup, Validators, FormControl } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { DataService } from 'src/app/shared/data.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { AuthService } from 'src/app/auth/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-buy-sponsor',
    templateUrl: './buy-sponsor.component.html',
    styleUrls: ['./buy-sponsor.component.scss'],
    standalone: false
})
export class BuySponsorComponent implements OnInit {

  addPromotionForm: FormGroup;
  userID: number;

  constructor(public dialog: MatDialog,
              private dataService: DataService,
              public dialogRef: MatDialogRef<BuySponsorComponent>,
              private authService: AuthService,
              private router: Router) {
                this.userID = this.authService.getUserData().id;
               }

  ngOnInit(): void {
    this.addPromotionForm = new FormGroup({
      codesNumber: new FormControl(null, [Validators.required]),
    });
  }


  closeDialog() {
    if (this.addPromotionForm.dirty) {
      const dialogRef = this.dialog.open(AlertDialogComponent, {
        disableClose: true,
        width: '400px',
        data: {
          title: 'Warning',
          type: 'Warn',
          message: 'You will miss your information once you close',
          buttonText: 'cancel',
          numberOfButtons: 2,
          seconButtonText: 'Ok'
        }
      });
      dialogRef.afterClosed().subscribe((status) => {
        if (status === 'Ok') {
          this.dialog.closeAll();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  numberOnly(event: any): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  onSubmit() {
    if (this.addPromotionForm.valid && parseInt(this.addPromotionForm.get('codesNumber').value.toString()) >0) {
      this.dialog.closeAll();

      this.router.navigate(['/billing/'+parseInt(this.addPromotionForm.get('codesNumber').value.toString(), 10)]);

      /*
       const payload = {
        percentage: 100,
        count: parseInt(this.addPromotionForm.get('codesNumber').value.toString(), 10),
        expireDate: null,
        userId: parseInt(this.userID.toString(), 10),
        isSponsored : true
      };
      this.dataService.post('promotionCode/GeneratePromotionCode', payload).then((data) => {
        if (data.statusCode === 200) {
          this.dialogRef.close(data.data);
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Success',
              type: 'Success',
              message: 'Sponsor code added successfully',
              buttonText: 'Ok'
            }
          });
        } else {
          const dialogRef = this.dialog.open(AlertDialogComponent, {
            disableClose: true,
            width: '400px',
            data: {
              title: 'Error',
              type: 'Error',
              message: 'Something went wrong, Please try again!',
              buttonText: 'Ok'
            }
          });
        }
      });*/
    }
  }

}
